export default __webpack_public_path__ + "static/media/cssCases.d135a3a1.png";